/**
 * Groupon.Utils.getConfigFromDom
 *
 * @param {string=} id
 * @return {Object}
 */
function mGetConfigFromDom(id = 'domConfig') {
  const el = document.getElementById(id);
  if (!(el && el.tagName === 'SCRIPT')) {
    return {};
  }
  const text = (el.textContent || el.innerText).trim();
  // textContent is more performant but only supported on IE 9+
  // see http://www.kellegous.com/j/2013/02/27/innertext-vs-textcontent/

  try {
    return JSON.parse(text);
  } catch (error) {
    error.message += `Attempted to parse:${text}`;
    throw error;
  }
}

module.exports = mGetConfigFromDom;
